import { Link } from 'react-router-dom';

export default function AustraliaHostLanding() {
  return (
    <div className="min-h-screen bg-white font-sans">
      {/* SECTION 1 — HERO */}
      <section
        className="relative min-h-screen flex flex-col justify-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Modern%20residential%20pontoon%20in%20Gold%20Coast%20canal%20estate%20with%20timber%20decking%20and%20secure%20boat%20mooring%2C%20luxury%20waterfront%20home%20with%20private%20jetty%20access%2C%20calm%20canal%20water%20reflecting%20blue%20sky&width=1920&height=1080&seq=gc-hero-001&orientation=landscape)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 60%',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-blue-700/60" />
        <div className="relative w-full max-w-3xl mx-auto px-6 py-20 text-center">
          <div className="inline-block bg-yellow-400 text-yellow-900 text-xs md:text-base font-bold px-4 py-2 md:px-6 md:py-3 rounded-full mb-8">
            Australia&apos;s Space-Sharing Marketplace
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
            Your spare space could earn up to $400/month
          </h1>
          <p className="text-xl md:text-2xl text-white mb-10 max-w-xl mx-auto">
            Free to list. No lock-in. Get paid monthly.
          </p>
          <Link
            to="/signup"
            className="inline-block bg-yellow-400 hover:bg-yellow-300 text-[#78350F] font-bold text-xl px-10 py-5 rounded-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            Create Free Account
          </Link>
          <p className="text-white text-xs md:text-2xl font-semibold mt-6">
            Takes 10 minutes · Cancel anytime · No obligations
          </p>
        </div>
      </section>

      {/* SECTION 2 — EARNINGS */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-center text-2xl font-bold text-gray-700 uppercase tracking-wider mb-4">
            What spaces earn per month
          </h2>
          <div className="flex items-center justify-center gap-2 mt-3 mb-10">
          <span className="inline-flex items-center gap-2 bg-teal-50 border border-teal-200 text-teal-800 text-base font-semibold px-5 py-3 rounded-full">
            <i className="ri-percent-line text-[#14B8A6]"></i>
            Stashly takes 10% — you keep 90% of everything you earn. No hidden fees.
          </span>
        </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: 'ri-home-4-line', label: 'Garage', range: '$200–$400/mo' },
              { icon: 'ri-car-line', label: 'Driveway', range: '$80–$180/mo' },
              { icon: 'ri-ship-line', label: 'Caravan or Boat Spot', range: '$150–$350/mo' },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-8 border border-gray-100 text-center"
              >
                <div className="w-14 h-14 mx-auto mb-5 bg-teal-100 rounded-xl flex items-center justify-center">
                  <i className={`${item.icon} text-[#14B8A6] text-2xl`}></i>
                </div>
                <div className="text-3xl font-extrabold text-gray-900 mb-2">{item.range}</div>
                <div className="text-gray-500 font-medium">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 3 — HOW IT WORKS */}
      <section className="py-20 md:py-28 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-14">
            List in 10 minutes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {[
              { n: '1', title: 'Create your free account' },
              { n: '2', title: 'Add photos and set your price' },
              { n: '3', title: 'Get paid every month' },
            ].map((step, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="w-14 h-14 bg-[#14B8A6] text-white text-2xl font-bold rounded-full flex items-center justify-center mb-5">
                  {step.n}
                </div>
                <p className="text-gray-700 font-medium">{step.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 4 — TRUST */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {[
              { icon: 'ri-shield-check-line', text: 'All renters ID-verified' },
              { icon: 'ri-bank-card-line', text: 'Secure monthly payments' },
              { icon: 'ri-check-double-line', text: 'You approve every booking' },
              { icon: 'ri-customer-service-line', text: 'Stashly support 7 days a week' },
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-4 bg-gray-50 rounded-xl p-6"
              >
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-[#14B8A6] text-2xl`}></i>
                </div>
                <span className="text-gray-900 font-bold text-base">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 5 — BOTTOM CTA */}
      <section className="py-24 md:py-32 bg-[#14B8A6]">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Ready to start earning?
          </h2>
          <p className="text-teal-50 text-lg mb-10">
            Free to list. No lock-in. Join hosts earning monthly income from their spare space.
          </p>
          <Link
            to="/signup"
            className="inline-block bg-yellow-400 hover:bg-yellow-300 text-[#78350F] font-bold text-xl px-10 py-5 rounded-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            Create Free Account
          </Link>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 py-6 text-center text-gray-500 text-sm">
        &copy; 2026 Stashly Technologies Pty Ltd ·{' '}
        <Link to="/terms" className="hover:text-white transition-colors">
          Terms
        </Link>{' '}
        ·{' '}
        <Link to="/privacy" className="hover:text-white transition-colors">
          Privacy
        </Link>
      </footer>
    </div>
  );
}
